import { render, staticRenderFns } from "./RankingTask.vue?vue&type=template&id=724ac686&scoped=true&"
import script from "./RankingTask.vue?vue&type=script&lang=ts&"
export * from "./RankingTask.vue?vue&type=script&lang=ts&"
import style0 from "./RankingTask.vue?vue&type=style&index=0&id=724ac686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ac686",
  null
  
)

export default component.exports